import * as React from 'react';
import { View } from 'react-native';

import type * as api from '@gitbook/api-client';
import { spacing, ThemedStyleSheet, useCurrentTheme } from '@gitbook/react-uikit';

import { ContentKitStackDirectionContent } from './ContentKitStack';

export function ContentKitDivider(props: { element: api.ContentKitDivider }): React.ReactElement {
    const { element } = props;
    const direction = React.useContext(ContentKitStackDirectionContent);
    const [, styles] = useCurrentTheme(themedStyles);
    const [, directionStyles] = useCurrentTheme(themedDirectionStyles);

    return (
        <View
            style={[
                styles.divider,
                directionStyles[direction],
                {
                    [direction === 'vstack' ? 'marginVertical' : 'marginHorizontal']:
                        spacing[element.size || '400'],
                },
            ]}
        />
    );
}

const themedStyles = ThemedStyleSheet.create({
    divider: (theme) => ({
        backgroundColor: theme.colors.border.mid,
    }),
});

const themedDirectionStyles = ThemedStyleSheet.create({
    vstack: () => ({
        height: 1,
        width: '100%',
        marginVertical: spacing.medium,
    }),
    hstack: () => ({
        width: 1,
        height: '100%',
        marginHorizontal: spacing.medium,
    }),
});
